<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-10-31 17:55:03
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-12-15 18:07:14
 * @FilePath: \vue-hepha-order\src\views\base\OrderSource.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>
        
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'prepaid_flag'" :style="{'color': props.record.prepaid_flag_val == 1? 'green' : 'red'}">
                    {{ props.record.prepaid_flag }}  
                </div>
            </template>

            <template v-slot:operate>
                <a-button 
                    v-permission="'setting.channelMap.syncERPChannels'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="syncERPChannels"
                >
                    <icon-sync size="13" style="marginRight:5px;"/>
                    {{ $t('customer.syncERPChannels') }}
                </a-button>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button 
                    v-permission="'setting.config.updateFreight'"
                    size="mini" class="form_btn" type="primary" 
                    style="width: 143px"
                    :disabled="props.record.type_val != 1" 
                    @click="updatePannel(props.record)"
                >
                    <icon-sync size="13" style="marginRight:5px;"/>
                    {{ $t('base.update') }}
                </a-button>
                <!-- v-permission="'setting.config.setDiscountRate'"  -->
                <a-button 
                    v-permission="'setting.config.setDiscountRate'"
                    size="mini" class="form_btn" type="primary" 
                    :disabled="props.record.type_val == 0" 
                    @click="handle('setDiscountRate', props.record)"
                >
                    <icon-settings size="13" style="marginRight:5px;"/>
                    {{ $t('config.setDiscountRate') }}
                </a-button>
            </template>
        </Table>

        <a-modal 
            v-model:visible="updateVisible" 
            :width="700"
            :onBeforeOk="updateBeforeOk" 
            @ok="handleUpdate" 
            @cancel="handleCancel"
        >
            <template #title>{{ $t('base.update') }}</template>
            <div style="text-align:center" v-if="updateVisible">
                <a-radio-group v-model="update_type" @change="changeRadio">
                    {{ $t('config.type') }}:
                    <a-radio value="pay">{{ $t('config.payDiscount') }}</a-radio>
                    <a-radio :disabled="rowData.payment_type != 'By Invoice'"  value="cash">{{ $t('config.cashDiscount') }}</a-radio>
                    <a-radio value="freight">{{ $t('config.freight') }}</a-radio>
                </a-radio-group>
                <div style="margin:15px 0 0 -205px">
                    {{ $t('config.discountFreight') }}:
                    <a-select 
                        v-if="update_type == 'pay' || update_type == 'cash'"
                        v-model="update_value"
                        :style="{width:'320px',marginLeft: '10px'}"
                        :options="update_type == 'pay'? payDiscountOpt : cashDiscountOpt"
                        placeholder="Please select ..."
                    ></a-select>
                    <a-input-number 
                        v-else
                        v-model="update_value" 
                        :style="{width:'320px',marginLeft: '10px'}"
                        class="input-demo" 
                        :min="0" 
                        :max="100"
                    />
                </div>
            </div>
        </a-modal>

        <!-- 设置折扣比例 -->
        <a-modal 
            v-model:visible="setDiscountRateVisible" 
            :width="500"
            :onBeforeOk="handleSetDiscountRate"
            @cancel="setDiscountRateVisible = false"
        >
            <template #title>{{ $t('config.setDiscountRate') }}</template>
            <div style="text-align:center" v-if="setDiscountRateVisible">
                <a-input-number v-model="discount_rate" hide-button :style="{width:'320px'}" :min="0" :max="100" >
                    <template #suffix>%</template>
                </a-input-number> 
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { BaseApi } from '@/api/BaseApi.js';
    import { CustomerApi } from '@/api/CustomerApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { OrderSourceQueryForm } from './queryConfig/AddForm'
    import { useI18n } from 'vue-i18n';
    import { QueryForm } from '../dashboard/queryConfig/QueryForm';

    const { t } = useI18n()

    const queryForm = reactive(OrderSourceQueryForm)
    const customer_name = ref('')
    const showForm = ref(false)
    const update_type = ref('pay')
    const update_value = ref('')
    const updateVisible = ref(false)
    const payDiscountOpt = ref([])
    const cashDiscountOpt = ref([])
    const pay_discount_arr = ref([])
    const cash_discount_arr = ref([])
    const rowData = ref(null)
    const discount_rate = ref('')
    const setDiscountRateVisible = ref(false)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '订单来源',
                title:t('order.orderSource'),
                dataIndex: 'customer_name',
                key:'customer_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 190,
            },
            {
                // title: '来源编码',
                title:t('order.customerNumber'),
                dataIndex: 'customer_number',
                key:'customer_number',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 220,
            },
            {
                // title: 'VAT号',
                title:t('config.vatNo'),
                dataIndex: 'vat_no',
                key:'vat_no',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 120,
            },  
            {
                // title: '客户类型',
                title:t('config.customerType'),
                dataIndex: 'type',
                key:'type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 140,
            },  
            {
                // title: '区域',
                title:t('order.area'),
                dataIndex: 'customer_class_code',
                key:'customer_class_code',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 170,
            },  
            {
                // title: '客户等级',
                title:t('order.hfCustomerLevel'),
                dataIndex: 'hf_customer_level',
                key:'hf_customer_level',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 150,
            },  
            {
                // title: '信用等级',
                title:t('config.creditLevel'),
                dataIndex: 'credit_level',
                key:'credit_level',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 130,
            }, 
            {
                // title: '状态',
                title:t('config.status'),
                dataIndex: 'status',
                key:'status',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 120,
            }, 
            {
                // title: '是否预付客户',
                title:t('order.prepaidCustomer'),
                dataIndex: 'prepaid_flag',
                key:'prepaid_flag',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:160,
                slotName:'slot',
            },  
            {
                // title: '支付方式',
                title:t('order.paymentType'),
                dataIndex: 'payment_type',
                key:'payment_type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:150,
            },  
            {
                // title: '账期',
                title:t('order.paymentDay'),
                dataIndex: 'payment_day',
                key:'payment_day',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 130,
            },
            {
                // title: '支付折扣',
                title:t('config.payDiscount'),
                dataIndex: 'payment_type_discount',
                key:'payment_type_discount',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 170,
            },
            {
                // title: '现金折扣',
                title:t('config.cashDiscount'),
                dataIndex: 'payment_with_days_discount',
                key:'payment_with_days_discount',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 150,
            },
            {
                // title: '运费',
                title:t('config.freight'),
                dataIndex: 'shipping_cost',
                key:'shipping_cost',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 150,
            },
            {
                // title: '现金折扣',
                title:t('config.discountRate'),
                dataIndex: 'pre_discount_rate',
                key:'pre_discount_rate',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width: 150,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'170',
                align:'left',
                fixed:'right'
            }  
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'reset':
                for(let key in queryForm.formData){
                    queryForm.formData[key] = ''
                }
                table.value.configs.pagination.current = 1
                getList()
                break;
            case 'setDiscountRate':
                setDiscountRateVisible.value = true
                discount_rate.value = ''
                rowData.value = row
                break;
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handlePressEnter = (val,item)=>{
        // console.log(val,item,'vvbnn')
        table.value.configs.pagination.current = 1
        getList()
    }

    const handleInputClear = (val,item)=>{
        // console.log(val,item,'vvbnn2222')
        table.value.configs.pagination.current = 1
        getList()
    }

    const search = (val)=>{
        table.value.configs.pagination.current = 1
        customer_name.value = val
        getList()
    }

    const handleSelectChange = (val)=>{
        // console.log(val,'vvvv')
        table.value.configs.pagination.current = 1
        getList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getList()
    }

    // 获取列表
    const getList = async ()=>{
        let param = {
            ...queryForm.formData,
            customer_name: queryForm.formData.customer_name.trim(),
            customer_number: queryForm.formData.customer_number.trim(),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await BaseApi.getInstance().getOrderSourceList(param,page_num,page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    No:index + 1,
                    customer_name: i.customer_name,
                    customer_number: i.customer_number,
                    customer_class_code: !i.customer_class_code? '-' :  i.customer_class_code,
                    hf_customer_level: !i.hf_customer_level? '-' : i.hf_customer_level,
                    credit_level:!i.credit_level? '-' : i.credit_level,
                    payment_day: i.payment_day == undefined? '-' : i.payment_day,
                    payment_type: i.payment_type == undefined? '-' : i.payment_type,
                    prepaid_flag_val: i.prepaid_flag,
                    prepaid_flag: i.prepaid_flag == 1? t('base.yes') : t('base.no'),
                    vat_no: !i.vat_no? '-' : i.vat_no,
                    type_val: i.type,
                    type: i.type === 0? t('order.user') : t('order.dealer'),
                    status: !i.status? '-' : i.status == 'A'? t('config.cooperate') : t('config.invalid'),
                    payment_type_discount: i.payment_type_discount == undefined? '-' : `${i.payment_type_discount * 100}%`,
                    payment_with_days_discount: i.payment_with_days_discount == undefined? '-' : `${i.payment_with_days_discount * 100}%`,
                    shipping_cost: i.shipping_cost == undefined? '-' : i.shipping_cost,
                    pre_discount_rate: i.pre_discount_rate == undefined? '-' : `${i.pre_discount_rate * 100}%`,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 同步ERP客户信息
    const syncERPChannels = async ()=>{
        table.value.configs.loading = true
        let res = await CustomerApi.getInstance().syncERPCustomer()
        if(res.code == 0){
            Message.success(t('base.syncSuccess'))
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    const updatePannel = (row)=>{
        updateVisible.value = true
        update_type.value = 'pay'
        update_value.value = ''
        rowData.value = row

        let pay_item_arr = pay_discount_arr.value.filter(i=> i.dict_sub_name == row.payment_type)
        let cash_item_arr = cash_discount_arr.value.filter(i=> i.dict_sub_name == row.payment_type) 
        console.log(pay_item_arr, 'item_arr',)

        payDiscountOpt.value = []
        cashDiscountOpt.value = []
        pay_item_arr.forEach(i=>{
            payDiscountOpt.value.push({
                label: i.dict_sub_value * 100 + '%',
                value: i.dict_sub_value,
            })
        })
        cash_item_arr.forEach(i=>{
            cashDiscountOpt.value.push({
                label: i.dict_sub_value * 100 + '%',
                value: i.dict_sub_value,
            })
        })
    }

    const changeRadio = ()=>{
        update_value.value = ''
    }

    const updateBeforeOk = ()=>{
        if(update_value.value === ''){
            Message.error(t('config.updateTip'))
            return false
        }

        return true
    }

    const handleUpdate = async()=>{
        let param = {
            customer_number: rowData.value.customer_number,
        }
        if(update_type.value == 'pay' || update_type.value == 'cash'){
            param.discount = update_value.value
        }else{
            param.freight = update_value.value
        }

        let res = update_type.value == 'pay'
                ? await BaseApi.getInstance().updatePayDiscount(param) 
                : update_type.value == 'cash'
                ? await BaseApi.getInstance().updateCashDiscount(param)
                : await BaseApi.getInstance().updateFreight(param)

        if(res.code == 0){
            Message.success(t('base.updateSuccess'))
            updateVisible.value = false
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    const handleCancel = ()=>{
        updateVisible.value = false
    }

    // 获取支付折扣下拉配置
    const getPayDiscountConfig = async()=>{
        let param = {
            dict_code: "dealer", 
            dict_sub_code:'payment_type_discount',
        }
        let res = await BaseApi.getInstance().getPayDiscountConfig(param) 
        if(res.code == 0){
            pay_discount_arr.value = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取现金折扣下拉配置
    const getCashDiscountConfig = async()=>{
        let param = {
            dict_code: "dealer", 
            dict_sub_code:'payment_with_days_discount',
        }
        let res = await BaseApi.getInstance().getCashDiscountConfig(param) 
        if(res.code == 0){
            cash_discount_arr.value = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 设置折扣比例
    const handleSetDiscountRate = async ()=>{
        if(discount_rate.value === '' || discount_rate.value === undefined){
            Message.error(t('config.discountRate')+ ' ' +t('base.noEmpty'))
            return false
        }
        let param = {
            customer_number: rowData.value.customer_number, 
            discount: discount_rate.value/100,
        }
        let res = await BaseApi.getInstance().setDiscountRate(param) 
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            setDiscountRateVisible.value = false
            getList()
            return true
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        getList()

        getPayDiscountConfig()
        getCashDiscountConfig()
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}



/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}

/deep/ .arco-form-item-label-col{
    width:0 !important;
}

/deep/ button:focus, button:focus-visible{
    outline:none;
}
</style>